import { z } from 'zod';
import { AssignmentGroupState } from './state.js';
/** An assignment group as primary serves it. */
export const AssignmentGroupSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    name: z.string(),
    description: z.string(),
    organizationId: z.uuid(),
    state: z.enum(AssignmentGroupState),
});
/** Path params for `GET /flow/data-access/assignment-groups/:id`. */
export const AssignmentGroupFindOneParamsSchema = z
    .object({
    id: z.uuid(),
})
    .strict();
//# sourceMappingURL=assignmentGroup.js.map